import { render, staticRenderFns } from "./consents.vue?vue&type=template&id=16d83053&scoped=true&"
import script from "./consents.vue?vue&type=script&lang=js&"
export * from "./consents.vue?vue&type=script&lang=js&"
import style0 from "./consents.vue?vue&type=style&index=0&id=16d83053&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d83053",
  null
  
)

export default component.exports